var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group", class: _vm.classObject }, [
    _vm.labelSide === "left"
      ? _c(
          "label",
          {
            class: [
              "control-label",
              "col-md-" + _vm.labelSize,
              _vm.disabled ? "" : "pointer"
            ],
            on: { click: _vm.onLabelClick }
          },
          [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.left",
            value: _vm.tooltip,
            expression: "tooltip",
            modifiers: { left: true }
          }
        ],
        class: "col-md-" + (12 - _vm.labelSize)
      },
      [
        _c(
          "label",
          {
            staticClass: "mt-checkbox mt-checkbox-outline",
            staticStyle: { "margin-top": "8px" }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.val,
                  expression: "val"
                }
              ],
              attrs: { type: "checkbox", disabled: _vm.disabled },
              domProps: {
                checked: Array.isArray(_vm.val)
                  ? _vm._i(_vm.val, null) > -1
                  : _vm.val
              },
              on: {
                change: function($event) {
                  var $$a = _vm.val,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.val = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.val = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span")
          ]
        ),
        _vm._v(" "),
        _vm.errorText
          ? _c("span", { staticClass: "help-block" }, [
              _c("p", [_vm._v(" " + _vm._s(_vm.errorText) + " ")])
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.labelSide === "right"
      ? _c(
          "label",
          {
            class: [
              "control-label",
              "pull-left",
              "col-md-" + _vm.labelSize,
              _vm.disabled ? "" : "pointer"
            ],
            on: { click: _vm.onLabelClick }
          },
          [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e941b9cc", { render: render, staticRenderFns: staticRenderFns })
  }
}